import { Card, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { AppIcon } from "../AppIcon";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import type { MiniStat } from "./types";

type Props = {
	stat: MiniStat;
};

export const MiniStatCard = ({ stat }: Props) => {
	const theme = useAppTheme();

	return (
		<FlatCard
			style={{
				borderRadius: theme.roundness * 4,
				flex: 1,
			}}
		>
			<Card.Content
				style={{
					paddingHorizontal: 8,
					paddingVertical: 12,
					flexGrow: 1,
					justifyContent: "center",
				}}
			>
				<Box gap={4} alignItems="center">
					<AppIcon
						name={stat.iconName}
						size={24}
						color={theme.colors.secondary}
					/>
					<Text
						variant="labelMedium"
						numberOfLines={2}
						style={{
							color: theme.colors.onSurfaceVariant,
							textAlign: "center",
						}}
					>
						{stat.label}
					</Text>
					<Text variant="bodyMedium" style={{ textAlign: "center" }}>
						{stat.statusText}
					</Text>
				</Box>
			</Card.Content>
		</FlatCard>
	);
};
